// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"dam"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 9L12 2L20 9V21H15V9H9V21H4V9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 21V9L12 2L20 9V21M4 21H3M4 21C8 21 5 21 9 21M20 21H21M20 21C20 21 16 21 14 21M9 9V21M9 9H15M9 9H4.75M9 21H10M15 9V21M15 9H19.25","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-dam')
export default class DamIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam',
    }
  }
}
